<!--
Copyright 2026 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<crucible-dialog
  [dialogTitle]="(data.level.id ? 'Edit' : 'Create') + ' Proficiency Level'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.level !== undefined && data.level !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Proficiency Level (e.g. Beginner, Intermediate, Expert)"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.level.name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Value</mat-label>
            <input
              type="number"
              title="The numeric value of the level"
              matInput
              placeholder="Value"
              [(ngModel)]="data.level.value">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Display Order</mat-label>
            <input
              type="number"
              title="The display order of the level"
              matInput
              placeholder="Display Order"
              [(ngModel)]="data.level.displayOrder">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Proficiency Level"
              matInput
              placeholder="Description"
              [(ngModel)]="data.level.description">
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
